import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const [infoOpenDesktop, setInfoOpenDesktop] = useState(false);
  const [servicesOpenDesktop, setServicesOpenDesktop] = useState(false);

  const [infoOpenMobile, setInfoOpenMobile] = useState(false);
  const [servicesOpenMobile, setServicesOpenMobile] = useState(false);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <>
      <header className={`header ${menuOpen ? "menu-open" : ""}`}>

        {/* LOGO */}
        <div className="logo">
          <img src="/logo.png" alt="לוגו" />
        </div>

        <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>

        {/* DESKTOP NAV */}
        <nav className="nav desktop-nav">
          <Link to="/">בית</Link>
          <Link to="/About">אודות</Link>

          {/* INFO */}
          <div
            className="dropdown"
            onMouseEnter={() => setInfoOpenDesktop(true)}
            onMouseLeave={() => setInfoOpenDesktop(false)}
          >
                <Link to="/ProfessionalInformation/" className="drop-title">מידע מקצועי ▾</Link>

            {infoOpenDesktop && (
              <div className="dropdown-menu">
                <Link to="/Roofrepair/">תיקון גגות</Link>
                <Link to="/Sealingexteriorwalls/">איטום קירות חיצוניים</Link>
                <Link to="/BuildingRehabilitation/">שיקום מבנים</Link>
                <Link to="/Rooftarps/">זיפות גגות</Link>
                <Link to="/Bituminoussheets/">יריעות ביטומניות</Link>
                <Link to="/Waterproofingroofswithbituminoussheets/">איטום גגות ביריעות ביטומניות</Link>
                <Link to="/Roofwaterproofingsheets/">יריעות איטום לגג</Link>
                <Link to="/Types_of_bituminous_sheets/">סוגי יריעות ביטומניות</Link>
                <Link to="/Hot_tar/">זפת חם</Link>
                <Link to="/Working_at_Height/">עבודה בגובה</Link>
                <Link to="/Working_in_abseiling/">עבודות סנפלינג</Link>
                <Link to="/Abseiling_sealing/">איטום בסנפלינג</Link>
                <Link to="/Rain_is_good_but_not_in_doors/">גשם זה טוב - לא בתוך הבית</Link>
                <Link to="/Leak_detection/">איתור נזילות</Link>
                <Link to="/How_to_choose_a_professional_for_roof_waterproofing/">   כיצד לבחור בעל מקצוע לאיטום גגות</Link>
                <Link to="/Different_methods_of_roof_sealing/"> שיטות שונות לאיטום גגות</Link>
                <Link to="/Live_on_the_roof_floor_in_a_building/">  גרים בקומת גג בבניין? כדאי שתדאגו  </Link>
              </div>
            )}
          </div>

          {/* SERVICES */}
          <div
            className="dropdown"
            onMouseEnter={() => setServicesOpenDesktop(true)}
            onMouseLeave={() => setServicesOpenDesktop(false)}
          >
              <Link to="/OurServices/"className="drop-title">השירותים שלנו ▾</Link>

            {servicesOpenDesktop && (
              <div className="dropdown-menu">
                <Link to="/Roof_waterproofing_bituminous_sheets">איטום יריעות ביטומניות</Link>
                <Link to="/Roof_tar_and_plastering">זיפות וסיוד</Link>
                <Link to="/Spray_sealing_of_ground_walls">  איטום קירות תת קרקעים בהתזה </Link>
                <Link to="/Sealing_Wet_Rooms"> איטום חדרים רטובים</Link>
                <Link to="/Installation_of_high_altitude_infrastructures"> התקנת תשתיות בגובה</Link>
                <Link to="/Betkal_Casting">יציקת בטקל</Link>
                <Link to="/Sealing_tiled_roofs_using_an_innovative_method">  איטום גגות מרוצפים בשיטה חדשנית</Link>
                <Link to="/Sealing_the_house_envelope"> איטום מעטפת הבית</Link>
                <Link to="/Solving_and_repairing_malfunctions_in_existing_sealing_systems"> פתרון ותיקון תקלות במערכות איטום </Link>
                <Link to="/Identifying_moisture_sources"> זיהוי מקורות רטיבות</Link>
                <Link to="/Diamond_Drilling">קידוחי יהלום</Link>
                <Link to="/Painting_work_for_the_purpose_of_sealing"> עבודות צביעה למטרת איטום</Link>
                <Link to="/Waterproofing_roofs_with_PVC_sheets">איטום גגות ע"י יריעות P.V.C </Link>
                <Link to="/Sealing_underground_structures"> איטום מבנים תת–קרקעיים </Link>
                <Link to="/Roof_sealing_with_pure_polyurethane_spraying">איטום גגות בהתזת פוליאוריטן טהור</Link>
                <Link to="/Sealing_around_windows_in_a_variety_of_solutions"> איטום סביב חלונות במגוון פתרונות</Link>
                <Link to="/Cleaning_windows_and_buildings_in_abseiling"> ניקיון חלונות ומבנים בסנפלינג</Link>
              </div>
            )}
          </div>

          <Link to="/SealingContractors">קבלני איטום</Link>
          <Link to="/WorksGallery">גלריית עבודות</Link>
          <Link to="/ContactSection2">צור קשר</Link>
        </nav>

        {/* LEFT */}
        <div className="left-section">

          <Link to="/ContactSection2" className="cta-btn">
            השאירו פרטים
          </Link>

            <a href="tel:0526422426" className="contact">
            <img src="/telephone.png" alt="טלפון" className="contact-icon" />
            <div className="contact-text">
              <span className="contact-title">לייעוץ ראשוני -</span>
              <span className="contact-number">052-6422426</span>
            </div>
          </a>

          {/* HAMBURGER */}
          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? "✕" : "☰"}
          </button>

        </div>
      </header>

      {/* OVERLAY */}
      <div
        className={`overlay ${menuOpen ? "show" : ""}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>

        <button className="close-btn" onClick={() => setMenuOpen(false)}>
          ✕
        </button>

        <Link to="/" onClick={() => setMenuOpen(false)}>בית</Link>

           <Link to="/About" onClick={() => setMenuOpen(false)}>
           אודות
        </Link>

        {/* INFO MOBILE */}
        <div className="mobile-dropdown">
          <div
            className="mobile-drop-title"
            onClick={() => setInfoOpenMobile(!infoOpenMobile)}
          >
               <Link to="/ProfessionalInformation/" className="drop-title">מידע מקצועי ▾</Link>
          </div>

          {infoOpenMobile && (
            <div className="mobile-submenu">
              <Link to="/Roofrepair/" onClick={() => setMenuOpen(false)}>תיקון גגות</Link>
              <Link to="/Sealingexteriorwalls/" onClick={() => setMenuOpen(false)}>איטום קירות חיצוניים</Link>
              <Link to="/BuildingRehabilitation/" onClick={() => setMenuOpen(false)}>שיקום מבנים</Link>
              <Link to="/Rooftarps/" onClick={() => setMenuOpen(false)}>זיפות גגות</Link>
              <Link to="/Bituminoussheets/" onClick={() => setMenuOpen(false)}>יריעות ביטומניות</Link>
              <Link to="/Waterproofingroofswithbituminoussheets/" onClick={() => setMenuOpen(false)}>איטום גגות ביריעות ביטומניות</Link>
              <Link to="/Roofwaterproofingsheets/" onClick={() => setMenuOpen(false)}>יריעות איטום לגג</Link>
              <Link to="/Types_of_bituminous_sheets/" onClick={() => setMenuOpen(false)}>סוגי יריעות ביטומניות</Link>
              <Link to="/Hot_tar/" onClick={() => setMenuOpen(false)}>זפת חם</Link>
              <Link to="/Working_at_Height/" onClick={() => setMenuOpen(false)}>עבודה בגובה</Link>  
              <Link to="/Working_in_abseiling/" onClick={() => setMenuOpen(false)}>עבודות סנפלינג</Link>
              <Link to="/Abseiling_sealing/" onClick={() => setMenuOpen(false)}>איטום בסנפלינג</Link>
              <Link to="/Rain_is_good_but_not_in_doors/" onClick={() => setMenuOpen(false)}>גשם זה טוב - לא בתוך הבית</Link>
              <Link to="/Leak_detection/" onClick={() => setMenuOpen(false)}>איתור נזילות</Link>
              <Link to="/How_to_choose_a_professional_for_roof_waterproofing/" onClick={() => setMenuOpen(false)}> כיצד לבחור בעל מקצוע לאיטום גגות</Link>
              <Link to="/Different_methods_of_roof_sealing/" onClick={() => setMenuOpen(false)}> שיטות שונות לאיטום גגות</Link>
              <Link to="/Live_on_the_roof_floor_in_a_building/" onClick={() => setMenuOpen(false)}> גרים בקומת גג בבניין? כדאי שתדאגו לאיטום הגג </Link>



            </div>
          )}
        </div>

        {/* SERVICES MOBILE */}
        <div className="mobile-dropdown">
          <div
            className="mobile-drop-title"
            onClick={() => setServicesOpenMobile(!servicesOpenMobile)}
          >
            <Link to="/OurServices/"className="drop-title">השירותים שלנו ▾</Link>
          </div>



          {servicesOpenMobile && (
            <div className="mobile-submenu">
              <Link to="/Roof_waterproofing_bituminous_sheets" onClick={() => setMenuOpen(false)}>  איטום גגות- יריעות ביטומניות </Link>
              <Link to="/Roof_tar_and_plastering" onClick={() => setMenuOpen(false)}>  זיפות וסיוד גגות</Link>
              <Link to="/Spray_sealing_of_ground_walls" onClick={() => setMenuOpen(false)}> איטום קירות תת קרקעים בהתזה / יריעות ביטומניות</Link>
              <Link to="/Sealing_Wet_Rooms" onClick={() => setMenuOpen(false)}> איטום חדרים רטובים </Link>
              <Link to="/Installation_of_high_altitude_infrastructures" onClick={() => setMenuOpen(false)}> התקנת תשתיות בגובה</Link>
              <Link to="/Betkal_Casting" onClick={() => setMenuOpen(false)}>יציקת בטקל</Link>
              <Link to="/Sealing_tiled_roofs_using_an_innovative_method" onClick={() => setMenuOpen(false)}>  איטום גגות מרוצפים בשיטה חדשנית</Link>
              <Link to="/Sealing_the_house_envelope" onClick={() => setMenuOpen(false)}> איטום מעטפת הבית</Link>
              <Link to="/Solving_and_repairing_malfunctions_in_existing_sealing_systems" onClick={() => setMenuOpen(false)}> פתרון ותיקון תקלות במערכות איטום קיימות</Link>
              <Link to="/Identifying_moisture_sources" onClick={() => setMenuOpen(false)}> זיהוי מקורות רטיבות</Link>
              <Link to="/Diamond_Drilling" onClick={() => setMenuOpen(false)}>קידוחי יהלום</Link>
              <Link to="/Painting_work_for_the_purpose_of_sealing" onClick={() => setMenuOpen(false)}> עבודות צביעה למטרת איטום</Link>
              <Link to="/Waterproofing_roofs_with_PVC_sheets" onClick={() => setMenuOpen(false)}> איטום גגות ע"י יריעות P.V.C</Link>
              <Link to="/Sealing_underground_structures" onClick={() => setMenuOpen(false)}>  איטום מבנים תת–קרקעיים </Link>
              <Link to="/Roof_sealing_with_pure_polyurethane_spraying" onClick={() => setMenuOpen(false)}> איטום גגות בהתזת פוליאוריטן טהור</Link>
              <Link to="/Sealing_around_windows_in_a_variety_of_solutions" onClick={() => setMenuOpen(false)}>איטום סביב חלונות במגוון פתרונות</Link>
              <Link to="/Cleaning_windows_and_buildings_in_abseiling" onClick={() => setMenuOpen(false)}> ניקיון חלונות ומבנים בסנפלינג</Link>




            </div>
          )}
        </div>

        <Link to="/SealingContractors" onClick={() => setMenuOpen(false)}>
          קבלני איטום
        </Link>

        <Link to="/WorksGallery" onClick={() => setMenuOpen(false)}>
          גלריית עבודות
        </Link>

        <Link to="/ContactSection2" onClick={() => setMenuOpen(false)}>
          צור קשר
        </Link>
      </div>
    </>
  );
}